<!-- =========================================================================================
File Name: RegisterJWT.vue
Description: Register Page for JWT
----------------------------------------------------------------------------------------
Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div class="clearfix">
    <vs-input
      class="w-full"
      data-vv-validate-on="blur"
      label-placeholder="Name"
      name="displayName"
      placeholder="Name"
      v-model="displayName"
      v-validate="'required|alpha_dash|min:3'"/>
    <span class="text-danger text-sm">{{ errors.first('displayName') }}</span>

    <vs-input
      class="w-full mt-6"
      data-vv-validate-on="blur"
      label-placeholder="Email"
      name="email"
      placeholder="Email"
      type="email"
      v-model="email"
      v-validate="'required|email'"/>
    <span class="text-danger text-sm">{{ errors.first('email') }}</span>

    <vs-input
      class="w-full mt-6"
      data-vv-validate-on="blur"
      label-placeholder="Password"
      name="password"
      placeholder="Password"
      ref="password"
      type="password"
      v-model="password"
      v-validate="'required|min:6|max:10'"/>
    <span class="text-danger text-sm">{{ errors.first('password') }}</span>

    <vs-input
      class="w-full mt-6"
      data-vv-as="password"
      data-vv-validate-on="blur"
      label-placeholder="Confirm Password"
      name="confirm_password"
      placeholder="Confirm Password"
      type="password"
      v-model="confirm_password"
      v-validate="'min:6|max:10|confirmed:password'"/>
    <span class="text-danger text-sm">{{ errors.first('confirm_password') }}</span>

    <vs-checkbox class="mt-6" v-model="isTermsConditionAccepted">I accept the terms & conditions.</vs-checkbox>
    <vs-button class="mt-6" to="/pages/login" type="border">Login</vs-button>
    <vs-button :disabled="!validateForm" @click="registerUserJWt" class="float-right mt-6">Register</vs-button>
  </div>
</template>

<script>
  export default {
    data ()
    {
      return {
        displayName:              '',
        email:                    '',
        password:                 '',
        confirm_password:         '',
        isTermsConditionAccepted: true
      }
    },
    computed: {
      validateForm ()
      {
        return !this.errors.any() && this.displayName !== '' && this.email !== '' && this.password !== '' && this.confirm_password !== '' && this.isTermsConditionAccepted === true
      }
    },
    methods:  {
      checkLogin ()
      {
        // If user is already logged in notify
        if (this.$store.state.auth.isUserLoggedIn())
        {

          // Close animation if passed as payload
          // this.$vs.loading.close()

          this.$vs.notify({
            title:    'Login Attempt',
            text:     'You are already logged in!',
            iconPack: 'feather',
            icon:     'icon-alert-circle',
            color:    'warning'
          })

          return false
        }
        return true
      },
      registerUserJWt ()
      {
        // If form is not validated or user is already login return
        if (!this.validateForm || !this.checkLogin()) return

        const payload = {
          userDetails: {
            displayName:     this.displayName,
            email:           this.email,
            password:        this.password,
            confirmPassword: this.confirm_password
          },
          notify:      this.$vs.notify
        }
        this.$store.dispatch('auth/registerUserJWT', payload)
      }
    }
  }
</script>
